import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal, Table } from 'react-bootstrap';
import StepNav from './StepNav.jsx';

const AddProjectModalXer = ({
	steps,
	step,
	hasFile,
	confirmAndClose,
	next,
	addProjectXerFileChange,
	xerProjects,
	xerProjId,
	onProjChange
}) => {
	const projects = Array.isArray(xerProjects) ? xerProjects : [];
	return (
		<React.Fragment>
			<Modal.Body>
				<StepNav steps={steps} step={step} />
				<Table className="projectSetupTable">
					<tbody>
						<tr>
							<td>Choose a schedule file</td>
							<td>
								<FormControl
									componentClass="input"
									onChange={addProjectXerFileChange}
									type="file"
									accept=".xer,.xml,application/xml,text/xml"
									label="Schedule File" />
								<div className="help-block" style={{ marginTop: 8, fontSize: 12 }}>
									Primavera P6 <code>.xer</code> or MS Project XML (File → Save As → XML). One P6 project is imported from each file. Binary <code>.mpp</code> is not supported.
								</div>
							</td>
						</tr>
						{projects.length > 0 && (
							<tr>
								<td>P6 project</td>
								<td>
									<p>This file has more than one P6 project and not exactly one is marked for export. Choose the project to import.</p>
									<FormControl
										componentClass="select"
										value={xerProjId || ''}
										onChange={onProjChange}
										aria-label="P6 project">
										{projects.map(project => (
											<option key={project.projId} value={project.projId}>
												{project.shortName || `Project ${project.projId}`}
												{project.dataDate ? ` — ${project.dataDate}` : ''}
												{` — ${project.taskCount || 0} activities`}
												{project.exportFlag === 'Y' ? ' — export' : ''}
											</option>
										))}
									</FormControl>
								</td>
							</tr>
						)}
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={confirmAndClose} bsStyle="danger" className="floatLeft">Cancel</Button>
				<Button bsStyle="primary" onClick={next} disabled={!hasFile}>Next</Button>
			</Modal.Footer>
		</React.Fragment>
	);
};

AddProjectModalXer.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number,
	hasFile: PropTypes.bool,
	confirmAndClose: PropTypes.func,
	next: PropTypes.func,
	addProjectXerFileChange: PropTypes.func,
	xerProjects: PropTypes.array,
	xerProjId: PropTypes.string,
	onProjChange: PropTypes.func
};

export default AddProjectModalXer;